export async function loadImage(imageObject) {
  return new Promise(function (resolve, reject) {
    const img = new Image();
    img.src = imageObject;
    resolve();
  });
}

export function loadImages(imagesObject) {
  return new Promise(function (resolve, reject) {
    Object.keys(imagesObject).map((key, index) => {
      const img = new Image();
      img.src = imagesObject[key];
    });
    resolve();
  });
}

export function loadImageFile(url) {
  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.onload = function () {
      resolve(url);
    };
    img.onerror = function () {
      reject(url);
    };
    img.src = url;
  });
}
